import React, { useState, useEffect } from 'react';
import { HexColorPicker } from "react-colorful";
import { hexToRGBA, rgbaToHex, parseColorJSON } from './color';
import { Box, Typography, TextField } from '@mui/material';

const ColorPicker = ({ value, onChange, label = "Color" }) => {
  const getHexFromValue = () => {
    if (!value) return '#5656ff';
    try {
      const rgbaObj = typeof value === 'string' ? parseColorJSON(value) : value;
      return rgbaToHex(rgbaObj);
    } catch {
      return '#5656ff';
    }
  };

  const [localColor, setLocalColor] = useState(getHexFromValue());

  useEffect(() => {
    const newHex = getHexFromValue();
    setLocalColor(newHex);
  }, [value]);

  const handleColorChange = (newHex) => {
    setLocalColor(newHex);
    const rgbaObj = hexToRGBA(newHex);
    onChange(JSON.stringify(rgbaObj));
  };

  const handleInputChange = (e) => {
    const newHex = e.target.value;
    if (/^#[0-9A-Fa-f]{0,6}$/.test(newHex)) {
      setLocalColor(newHex);
      if (newHex.length === 7) {
        const rgbaObj = hexToRGBA(newHex);
        onChange(JSON.stringify(rgbaObj));
      }
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>
        {label}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {/* preview*/}
        <Box
          sx={{
            backgroundColor: localColor,
            width: '40px',
            height: '40px',
            borderRadius: '8px',
            border: '1px solid #ddd',
            flexShrink: 0
          }}
        />

        {/* input hex */}
        <TextField
          value={localColor.toUpperCase()}
          onChange={handleInputChange}
          placeholder="#5656FF"
          size="small"
          sx={{
            width: '120px',
            '& .MuiOutlinedInput-root': {
              fontFamily: 'monospace',
              fontSize: '14px'
            }
          }}
        />
      </Box>

      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        '& .react-colorful': {
          width: '100%',
          maxWidth: '250px'
        }
      }}>
        <HexColorPicker color={localColor} onChange={handleColorChange} />
      </Box>
    </Box>
  );
};

export default ColorPicker;